module.exports = __webpack_public_path__ + "static/media/lu.7df28e11.svg";